import { useEffect, useState } from 'react';
import { DefaultHeader } from './defaultHeader';
import ReactDOM from 'react-dom';
import '../studyCreationGuide.scss';
import { InitialState } from './initialState';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '../../../../../../component';
import nls from '../../../nls/pt-BR.json';
import { useTypedSelector } from '../../../../../../hooks/useTypedSelector';
import {
  advanceToStep,
  changePositionTo,
  setCurrentProgressTo,
  setInitialStep,
  studiesSelector,
} from '../../../redux/studies.reducer';
import { clearMap, setDisplayCharts } from '../../../../redux/dashboardActions';
import { ExitGuideButton } from './exitGuideButton';
import { PreviousStepButton } from './previousStepButton';
import { StepHeader } from './stepHeader';

interface StudyCreationGuideWrapperProps {
  children?: React.ReactNode;
  hasCustomButtons?: boolean;
}

export const StudyCreationGuideWrapper: React.FC<
  StudyCreationGuideWrapperProps
> = ({ children, hasCustomButtons = false }) => {
  const { translatePos } = useTypedSelector((state) => state.studies);
  const [displayChildren, setDisplayChildren] = useState<boolean>(true);
  const dispatch = useDispatch();
  const { currentStep } = useSelector(studiesSelector);
  let portalNode = document.getElementsByClassName('box-map-google')[0];
  if (!portalNode) {
    portalNode = document.createElement('div');
    portalNode.setAttribute('style', 'width: 100vw; height: 100vh');
    portalNode.setAttribute('id', 'studyCreationGuidePortal');
    document.body.appendChild(portalNode);
  }
  const handleClickNextStep = () => {
    dispatch(advanceToStep(currentStep.nextStep));
  };
  useEffect(() => {
    return () => {
      dispatch([
        clearMap(),
        changePositionTo({ x: 0, y: 0 }),
        setCurrentProgressTo(0),
        advanceToStep('initialState'),
        setDisplayCharts(null),
        setInitialStep(null),
      ]);
    };
  }, []);
  const JSX = (
    <div
      className="study-creation-guide"
      id="StudyCreationGuideContainer"
      style={{
        transform: `translateX(${translatePos.x}px) translateY(${translatePos.y}px)`,
      }}
    >
      {currentStep.nextStep === 'dragAndDropInstructions' ? (
        <InitialState />
      ) : (
        <>
          <DefaultHeader
            displayChildren={displayChildren}
            setDisplayChildren={setDisplayChildren}
          />
          <div
            className={`study-creation-guide__children-container ${
              displayChildren ? 'open' : 'closed'
            }`}
          >
            {currentStep.step && (
              <StepHeader
                stepNumber={currentStep.step}
                title={
                  nls.studyCreationGuide.sectionTitles[
                    `step${currentStep.step}` as keyof typeof nls.studyCreationGuide.sectionTitles
                  ]
                }
              />
            )}
            {children}
            {hasCustomButtons ? (
              hasCustomButtons
            ) : (
              <>
                <div className="study-creation-guide__buttons-container">
                  <div>
                    <ExitGuideButton />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      gap: 8,
                    }}
                  >
                    <PreviousStepButton />
                    <Button
                      className="btn normal primary"
                      cy="StudyCreationGuideNextStep"
                      disabled={!currentStep.canAdvance}
                      onClick={handleClickNextStep}
                    >
                      {nls.studyCreationGuide.buttons.nextStep}
                    </Button>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
  return ReactDOM.createPortal(JSX, portalNode);
};
